import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=16799c63&scoped=true&"
import script from "./Dashboard.ts?vue&type=script&lang=ts&"
export * from "./Dashboard.ts?vue&type=script&lang=ts&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=16799c63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16799c63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
